// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "./PaymentMethodsRecord.bs.js";

function usePaypalTokenAndFlowFromExperience(paypalPaymentMethodExperience, sessionObj) {
  let paypalToken = React.useMemo(() => SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Paypal"), [sessionObj]);
  let isPaypalSDKFlow = paypalPaymentMethodExperience.includes("InvokeSDK");
  let isPaypalRedirectFlow = paypalPaymentMethodExperience.includes("RedirectToURL");
  return {
    paypalToken: paypalToken,
    isPaypalSDKFlow: isPaypalSDKFlow,
    isPaypalRedirectFlow: isPaypalRedirectFlow
  };
}

function usePaymentMethodData(paymentMethodListValue, sessionObj) {
  let paypalPaymentMethodExperience = React.useMemo(() => PaymentMethodsRecord$OrcaPaymentPage.getPaymentExperienceTypeFromPML(paymentMethodListValue, "wallet", "paypal"), [paymentMethodListValue]);
  return usePaypalTokenAndFlowFromExperience(paypalPaymentMethodExperience, sessionObj);
}

export {
  usePaypalTokenAndFlowFromExperience,
  usePaymentMethodData,
}
/* react Not a pure module */
